// Business.js
import Image from "next/image";
import Link from "next/link";
import BusinessBrands from "./BusinessBrands";

const Business = () => {
  const pointers = [
    {
      icon: "https://d3kl8zsmmx4oop.cloudfront.net/si_Movie_e70fcd3f84.svg",
      title: "Self-paced video content",
      description:
        "Master new skills on your schedule with our flexible, self-paced video content.",
    },
    {
      icon: "https://d3kl8zsmmx4oop.cloudfront.net/si_Target_c6f22015fa.svg",
      title: "Office hours with Mentors for clearing blockers",
      description:
        "Overcome challenges fast with dedicated mentor office hours.",
    },
    {
      icon: "https://d3kl8zsmmx4oop.cloudfront.net/si_Copy_alt_6d34ac6c00.svg",
      title: "Project driven approach to achieve outcomes",
      description:
        "Gain practical skills through our project-driven approach for real results.",
    },
    {
      icon: "https://d3kl8zsmmx4oop.cloudfront.net/si_User_alt_cc0bd5ef2f.svg",
      title: "Access to network of 1000+ learners",
      description:
        "Tap into our vibrant network of learners, enhancing your learning experience.",
    },
  ];

  return (
    <div
      className="w-full py-10 md:py-20"
      style={{ backgroundColor: "rgb(255, 250, 241)" }}
      id="business"
    >
      <div className="w-[90%] md:w-[80%] mx-auto mb-12 md:mb-0">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row items-center justify-between mb-8 md:mb-12">
          <div className="md:w-3/4">
            <p className="text-sm md:text-base uppercase font-medium tracking-wide text-gray-600 mb-4">
              Skill Up, Scale Up
            </p>
            <h2 className="text-3xl md:text-[36px] font-medium mb-4">
              Upskill your Team; Upscale your Business
            </h2>

            <p className="text-gray-600 text-sm md:text-base font-normal">
              Elevate your team&apos;s skills to fuel efficiency and ongoing
              innovation for sustained business growth.
            </p>
          </div>
          <div className="mt-6 md:mt-0 md:w-1/4 flex justify-end">
            <Link
              href="https://home.growthschool.io/b2b"
              className="font-medium hidden md:block px-6 cursor-pointer bg-white py-3 text-sm md:text-base border hover:text-white border-black hover:bg-[#012726] rounded-xl text-center"
            >
              Upskill Your Team
            </Link>
          </div>
        </div>

        {/* Section Title Above Cards */}
        <h3 className="text-base font-medium mb-3">
          Why learn with GrowthSchool?
        </h3>

        {/* Pointer Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {pointers.map((pointer, index) => (
            <div key={index} className="flex items-start gap-4 md:p-4">
              <div
                className="flex-shrink-0 w-[74px] h-[74px] rounded-xl flex items-center justify-center"
                style={{ backgroundColor: "rgba(3, 10, 33, 0.05)" }}
              >
                <Image
                  src={pointer.icon}
                  alt={pointer.title}
                  width={42}
                  height={42}
                  sizes="42px"
                />
              </div>
              <div>
                <div className="text-base font-medium mb-2">
                  {pointer.title}
                </div>
                <p className="text-gray-600 font-normal text-sm md:text-base">
                  {pointer.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <BusinessBrands />
      <div className=" w-full flex justify-center">
        <Link
          href="https://home.growthschool.io/b2b"
          className="w-full font-medium md:hidden block px-6 cursor-pointer bg-white py-3 text-sm md:text-base border hover:text-white border-black hover:bg-[#012726] rounded-xl text-center"
        >
          Upskill Your Team
        </Link>
      </div>
    </div>
  );
};

export default Business;
